import { useState } from 'react';

import { ReactComponent as WarningSVG } from '../../icons/warning.svg';

const IntellioWarning = ({ title, message }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="mb10 treatment-info-wrapper w-100 mih25 flex flex-row pa4">
      <div className="flex-auto flex-grow-0 pa2">
        <WarningSVG className="svg-warning" />
      </div>
      <div className="flex-auto flex flex-column justify-between pa1">
        <div className="fw5 red-d3">{title}</div>
        <div className="red-d1 fw3">
          Please, check your entries and try again.
        </div>
        <div
          className="mt4 red-d1 fw3 underline pointer"
          onClick={() => setOpen(!open)}
        >
          Details
        </div>
        {open && <div className="mt4 red-d1 fw3">{message}</div>}
      </div>
    </div>
  );
};

export default IntellioWarning;
